import { apiClient } from './client';

/**
 * Отрендерить XML документа ЭДО в PDF через наш прокси (сервис xmledo2pdf) и
 * открыть его в новой вкладке. Возвращает false, если открыть не удалось.
 */
export async function visualizePdf(fileName: string, xml: string): Promise<void> {
  const res = await apiClient.post('/pdf-viz', { fileName, xml }, { responseType: 'blob' });
  const url = URL.createObjectURL(res.data as Blob);
  const w = window.open(url, '_blank', 'noopener,noreferrer');
  if (!w) {
    // Попап заблокирован — скачиваем файл.
    const a = document.createElement('a');
    a.href = url;
    a.download = `${fileName}.pdf`;
    a.click();
  }
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
